import { FC, memo } from 'react'
import Pill from './Pill'
import { GpsSupplyRequest } from './types/types'

import styles from './Status.module.scss'

type StatusProps = {
  petition: GpsSupplyRequest
  dropName?: string
}

const Status: FC<StatusProps> = ({ petition, dropName }) => {
  const { reviewStatus, amount } = petition

  return (
    <div data-test-id="gps_petition_status_container">
      <div className={styles.statusContainer}>
        <Pill status={reviewStatus} approvedAmount={amount} />
      </div>
    </div>
  )
}

export default memo(Status)
